import { useCallback } from "react";
import { GlossaryId } from "../lib";
import { useDeleteDeeplGlossary } from "../services";

export const useDeleteGlossary = () => {
    const { deleteDeeplGlossary } = useDeleteDeeplGlossary();

    const deleteGlossary = useCallback(
        async (id: GlossaryId) => {
            try {
                await deleteDeeplGlossary(id);
            } catch (error) {
                if (error instanceof Error) {
                    throw new Error(`Could not delete glossary: ${error.message}`);
                } else {
                    throw new Error("Could not delete glossary: Unknown error");
                }
            }
        },
        [deleteDeeplGlossary]
    );

    return { deleteGlossary };
};
